<template>

  <div class="donate_prime_detail_wrap">
    <div class="donate_prime_detail">
      <page-header class="not_main"></page-header>
      <div class="donate_prime_detail_content">

        <image-component :infoType="'donateBanner'"></image-component>

        <div class="donate_prime_detail_content_box">
          <board-detail-component :boardType="`donateDetail`" :boardKey="boardKey"></board-detail-component>
<!--          <div class="donate_prime_detail_content_box_bottom">-->
<!--            <button class="donate_prime_detail_content_box_bottom_backBtn" @click="backEvent()">목록</button>-->
<!--          </div>-->
        </div>
      </div>
      <page-footer class="not_main"></page-footer>
    </div>
  </div>
</template>

<script>
import BoardDetailComponent from "@/components/board/BoardDetailComponent";
import ImageComponent from "@/components/information/ImageComponent";

export default {
  name: "DonatePrimeDetail",
  mixins: [],
  components: {BoardDetailComponent, ImageComponent},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      boardKey: ''
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.getBoardKey()
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    getBoardKey() {
      this.boardKey = this.$route.params.wr_id
    },
    backEvent() {
      this.$router.back();
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>